// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__SJ4Lk","head":"ProcedureTableInfo_head__Z8vlI"};